import React from 'react';
import { Col, Popover, Row, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';

export interface CertificationReportItemProps {
  item: {
    id?: string;
    _id?: string;
    employee_name: string;
    designation: string | null;
    certification_count: number;
    certifications: string[];
  };
}

const CertificationReportItem: React.FC<CertificationReportItemProps> = ({ item }) => {
  const navigate = useNavigate();
  const profileId = item.id || item._id;
  const certs = item.certifications || [];

  return (
    <Row className={styles.row}>
      {/* 1. Name - Clickable redirect to profile */}
      <Col span={6}>
        <div
          className={styles['name-col']}
          onClick={() => {
            if (profileId) {
              navigate(`/admin/employee/${profileId}`);
            }
          }}
        >
          <p className={styles['name-text']}>
            <b>{item.employee_name || 'N/A'}</b>
          </p>
        </div>
      </Col>

      {/* 2. Designation */}
      <Col span={5}>
        <div className={styles['text-col']}>
          <p className={styles.text}>{item.designation || 'N/A'}</p>
        </div>
      </Col>

      {/* 3. Count */}
      <Col span={3}>
        <div className={styles['text-col']}>
          <p className={styles.text}>{item.certification_count}</p>
        </div>
      </Col>

      {/* 4. Certifications: 1-2 pills + Popover View More (or dash if 0) */}
      <Col span={10}>
        <div className={styles['certs-col']}>
          <div className={styles['cert-text']}>
            {certs.length === 0 ? (
              <span style={{ color: '#8c8c8c' }}>—</span>
            ) : (
              <>
                {certs.slice(0, 2).map((title: string, index: number) => (
                  <Space className={styles['cert-box']} key={index}>
                    {title}
                  </Space>
                ))}

                {certs.length > 2 && (
                  <Space style={{ cursor: 'pointer', marginLeft: '6px' }}>
                    <Popover
                      placement="bottom"
                      title="Certifications"
                      content={
                        <div style={{ maxWidth: '350px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                          {certs.map((title: string, index: number) => (
                            <Space className={styles['cert-box-popover']} key={index}>
                              {title}
                            </Space>
                          ))}
                        </div>
                      }
                    >
                      <span className={styles['view-more']}>... View more</span>
                    </Popover>
                  </Space>
                )}
              </>
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default CertificationReportItem;
